import {collection,doc,runTransaction,serverTimestamp} from "firebase/firestore";
import {db} from "../firebaseConfig";
import {cleanProduct,invoiceQuantity} from "./invoiceModel";
import {cents,needValues} from "./bannerModel";

function checkVersion(snapshot,expected) {
  if(!snapshot.exists())throw new Error("Record no longer exists.");
  if(snapshot.data().updatedAt?.toMillis()!==expected?.toMillis())throw new Error("Record changed. Reopen it and review the latest version.");
}
export async function saveProduct(draft,previous) {
  const data=cleanProduct(draft),reference=previous ? doc(db,"banner_products",previous.id) : doc(collection(db,"banner_products"));
  await runTransaction(db,async transaction=>{
    if(previous)checkVersion(await transaction.get(reference),previous.updatedAt);
    transaction.set(reference,{...data,createdAt:previous ? previous.createdAt : serverTimestamp(),updatedAt:serverTimestamp()});
  });
}
export async function deleteProduct(product) {
  const reference=doc(db,"banner_products",product.id);
  await runTransaction(db,async transaction=>{
    checkVersion(await transaction.get(reference),product.updatedAt);
    transaction.delete(reference);
  });
}
export async function saveInvoiceLine(jobId,productId,quantity,previous) {
  const count=invoiceQuantity(quantity),reference=previous ? doc(db,"banner_jobs",jobId,"invoice_lines",previous.id) : doc(collection(db,"banner_jobs",jobId,"invoice_lines"));
  await runTransaction(db,async transaction=>{
    const job=await transaction.get(doc(db,"banner_jobs",jobId));
    if(!job.exists() || job.data().deletedAt)throw new Error("This job is unavailable or deleted.");
    let data;
    if(previous){const current=await transaction.get(reference);checkVersion(current,previous.updatedAt);const row=current.data();data={productId:row.productId,name:row.name,kind:row.kind,unitCents:row.unitCents,createdAt:row.createdAt};}
    else {
      if(!productId)throw new Error("Choose a product.");
      const product=await transaction.get(doc(db,"banner_products",productId));
      if(!product.exists() || !product.data().active)throw new Error("Product is no longer available. Choose an active product.");
      const row=product.data();data={productId,name:row.name,kind:row.kind,unitCents:row.unitCents,createdAt:serverTimestamp()};
    }
    if(data.kind==="senior" && job.data().seniorPayment!=="invoice")throw new Error("Senior banners must be set to Invoice in job needs before adding them to an invoice.");
    transaction.set(reference,{...data,quantity:count,updatedAt:serverTimestamp()});
  });
}
export async function removeInvoiceLine(jobId,line) {
  await runTransaction(db,async transaction=>{const reference=doc(db,"banner_jobs",jobId,"invoice_lines",line.id);checkVersion(await transaction.get(reference),line.updatedAt);transaction.delete(reference);});
}

export async function saveInvoiceNotes(jobId,notes,expectedNotes="") {
  if(typeof notes!=="string" || notes.length>4000)throw new Error("Invoice notes must be 4,000 characters or fewer.");
  await runTransaction(db,async transaction=>{
    const reference=doc(db,"banner_jobs",jobId,"invoice_details","summary");
    const [job,current]=await Promise.all([transaction.get(doc(db,"banner_jobs",jobId)),transaction.get(reference)]);
    if(!job.exists() || job.data().deletedAt)throw new Error("This job is unavailable or deleted.");
    if((current.exists() ? current.data().notes : "")!==expectedNotes)throw new Error("Invoice notes changed. Review the saved notes before saving again.");
    transaction.set(reference,{notes:notes.trim(),updatedAt:serverTimestamp()});
  });
}

export async function saveMiscInvoiceLine(jobId,title,quantity,price) {
  const count=invoiceQuantity(quantity),unitCents=cents(price);
  const name=String(title || "").trim();
  if(!name || name.length>200)throw new Error("Enter a miscellaneous title in job needs first.");
  const reference=doc(collection(db,"banner_jobs",jobId,"invoice_lines"));
  await runTransaction(db,async transaction=>{
    const job=await transaction.get(doc(db,"banner_jobs",jobId));
    if(!job.exists() || job.data().deletedAt)throw new Error("This job is unavailable or deleted.");
    if(!needValues(job.data().needs?.miscellaneous).includes(name))throw new Error("The miscellaneous item changed. Review job needs before adding it to the invoice.");
    transaction.set(reference,{productId:"",kind:"other",name,unitCents,quantity:count,createdAt:serverTimestamp(),updatedAt:serverTimestamp()});
  });
}
